const DEAL_STAGES = [
  { id: "discovery", title: "Discovery", color: "var(--color-action-secondary)" },
  { id: "demo", title: "Demo", color: "var(--color-warning)" },
  { id: "negotiation", title: "Negotiation", color: "var(--color-action-primary)" },
  { id: "won", title: "Won", color: "var(--color-highlight)" },
  { id: "lost", title: "Lost", color: "var(--color-danger)" },
];

const DEAL_STAGE_IDS = new Set(DEAL_STAGES.map((stage) => stage.id));

function normalizeDealStage(stage) {
  const value = String(stage || "").trim().toLowerCase();
  return DEAL_STAGE_IDS.has(value) ? value : "discovery";
}

export { DEAL_STAGES, normalizeDealStage };
